import { Button, Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import { SimulateBreakEntity } from 'domain/entities/SimulateEntity';
import moment from 'moment';
import SelectionDynamic from 'presentation/components/SelectionDynamic';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import InputAllowNumber from '../../CU-010-01/components/Input';

type props = {
    form: any;
    getCollapseProps: () => any;
    service: SimulateUseCaseInterface;
    onSubmit: (values: any) => void;
    scrollTop: () => void;
    saveData: () => void;
    btnDisable: boolean;
    setBtnDisable: (value: boolean) => void;
};

const FormSimulateSale = ({
    form,
    getCollapseProps,
    onSubmit,
    scrollTop,
    saveData,
    btnDisable,
    setBtnDisable,
}: props) => {
    const navigate = useNavigate();

    React.useEffect(() => {
        scrollTop();
    }, []);

    const onChangeForm = () => {
        if (
            Object.values(form.getFieldsValue()).some(
                (item: any) => item === undefined || item === '',
            )
        )
            setBtnDisable(true);
        else setBtnDisable(false);
    };

    const optionFill = () => {
        const options: any[] = [];
        for (let i = 1; i <= 99; i++) {
            options.push({
                value: `${i}`,
                label: `${i}年`,
            });
        }

        return options;
    };
    const options = optionFill();

    const replace = (value: string) => {
        return value.replaceAll(',', '');
    };

    const itemRules = {
        loanReceivable: [
            {
                required: true,
                message: getMessage('In_Required', '貸付金'),
            },
        ],
        annualInterest: [
            {
                required: true,
                message: getMessage('In_Required', '年利'),
            },
        ],
        rent: [
            {
                required: true,
                message: getMessage('In_Required', '家賃'),
            },
        ],
        managementFee: [
            {
                required: true,
                message: getMessage('In_Required', '管理費・修繕積立金・その他'),
            },
        ],
        repaymentPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '返済年数'),
            },
        ],
    };

    const submitForm = (values: any) => {
        const payload: SimulateBreakEntity = {
            drawdownDate: moment().format(DATE_FORMAT.FORMAT1),
            loanReceivable: Number(replace(values.loanReceivable)),
            annualInterest: Number(replace(values.annualInterest)),
            rent: Number(replace(values.rent)),
            managementFee: Number(replace(values.managementFee)),
            repaymentPeriod: Number(replace(values.repaymentPeriod)),
            fluctuationRate: 0,
            managementFeeFluctuationAmount: 0,
            simId: null,
        };
        onSubmit(payload);
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form form={form} onChange={onChangeForm} onFinish={submitForm}>
                    <div {...getCollapseProps()}>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.LOAN_RECEIVABLE}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="loanReceivable"
                                    maxLength={9}
                                    min={0}
                                    rules={itemRules.loanReceivable}
                                    label="貸付金"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.ANNUAL_INTEREST}
                                    suffix={'%'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="annualInterest"
                                    fraction={true}
                                    max={99.99}
                                    min={0}
                                    maxLength={5}
                                    rules={itemRules.annualInterest}
                                    label="年利"
                                />
                            </div>
                        </div>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.RENT}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="rent"
                                    maxLength={7}
                                    min={0}
                                    rules={itemRules.rent}
                                    label="家賃"
                                />
                            </div>
                            <div className="simulate-form-input">
                                <InputAllowNumber
                                    placeholder={PLACEHOLDER.MANAGEMENT_FEE_AND_OTHER_EXPENSES}
                                    suffix={'円'}
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        height: CONSTANTS.INPUT_HEIGHT,
                                        border: CONSTANTS.INPUT_BORDER,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    name="managementFee"
                                    maxLength={7}
                                    min={0}
                                    rules={itemRules.managementFee}
                                    label="管理費・修繕積立金・その他"
                                />
                            </div>
                        </div>
                        <div className="simulate-form-item">
                            <div className="simulate-form-input">
                                <span>
                                    返済年数<span style={{ color: '#EB5757' }}>*</span>
                                </span>
                                <SelectionDynamic
                                    style={{
                                        width: CONSTANTS.INPUT_WIDTH,
                                        background: '#fff',
                                    }}
                                    icon={<img src={DropdownIcon} alt="dropdown icon" />}
                                    options={options}
                                    name="repaymentPeriod"
                                    onChange={onChangeForm}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-option"
                            style={{
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                background: `${btnDisable ? '#D0D3D8' : '#fff'}`,
                            }}
                            onClick={() => (!btnDisable ? form.submit() : null)}
                        >
                            再実行
                        </div>
                        <Button
                            disabled={btnDisable}
                            className="simulate-form-option"
                            style={{
                                background: '#4BCAE5',
                                color: '#fff',
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                            }}
                            onClick={() => (!btnDisable ? saveData() : null)}
                        >
                            実行結果を保存
                        </Button>
                    </div>
                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-button"
                            style={{ backgroundColor: '#1F8DDD' }}
                            onClick={() =>
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_01}`)
                            }
                        >
                            出品中物件リストへ
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
